import React from "react";
// import { Link } from "react-router-dom";
import SNSLogo from "Assets/Images/SNSLogo.png";
import mainLogo from "Assets/Images/mainLogo.png";
import countryLogo from "Assets/Images/countryLogo.png";

import countryLogoMobile from "Assets/Images/countryLogoMobile.png";
import mainSNS from "Assets/Images/mainSNS.png";

export default class extends React.Component {
  state = {
    width: window.innerWidth
  };

  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 768;

    return (
      <div className="headerNav_Wrap">
        <div className="headerNav">
          <div id="SNS">
            <div className="SNS_Wrap">
              <img src={SNSLogo} alt="SNSLogo" id="sns" />
              <div className="SNS_item">
                <div id="item_wrap_country">
                  <a
                    href="https://www.instagram.com/mediflower_medical_group/"
                    target="_blank"
                  >
                    <div id="instagram"></div>
                  </a>
                  <a
                    href="https://www.facebook.com/mediflowerhospital/"
                    target="_blank"
                  >
                    <div id="facebook"></div>
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCAUODaW7e0w140LAUPjTY-g"
                    target="_blank"
                  >
                    <div id="youtube"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div id="Logo">
            <img src={mainLogo} alt="mainLogo" id="main" />
          </div>
          <div id="Country">
            <div className="country_Wrap">
              <img
                src={isMobile ? countryLogoMobile : countryLogo}
                alt="countryLogo"
                id="country"
              />
              <div className="country_item">
                <div id="item_wrap" className="cn">
                  <a href="http://www.medi-flower.com">
                    <div id="kr"></div>
                  </a>
                  <a href="http://us.medi-flower.com">
                    <div id="us"></div>
                  </a>
                  <a href="http://jp.medi-flower.com">
                    <div id="jp"></div>
                  </a>
                  <a href="http://rs.medi-flower.com">
                    <div id="rs"></div>
                  </a>
                </div>
                <div id="item_wrap" className="jp">
                  <a href="http://www.medi-flower.com">
                    <div id="kr"></div>
                  </a>
                  <a href="http://us.medi-flower.com">
                    <div id="us"></div>
                  </a>
                  <a href="http://cn.medi-flower.com">
                    <div id="cn"></div>
                  </a>
                  <a href="http://rs.medi-flower.com">
                    <div id="rs"></div>
                  </a>
                </div>
                <div id="item_wrap" className="us">
                  <a href="http://www.medi-flower.com">
                    <div id="kr"></div>
                  </a>
                  <a href="http://cn.medi-flower.com">
                    <div id="cn"></div>
                  </a>
                  <a href="http://jp.medi-flower.com">
                    <div id="jp"></div>
                  </a>
                  <a href="http://rs.medi-flower.com">
                    <div id="rs"></div>
                  </a>
                </div>
                <div id="item_wrap" className="rs">
                  <a href="http://www.medi-flower.com">
                    <div id="kr"></div>
                  </a>
                  <a href="http://us.medi-flower.com">
                    <div id="us"></div>
                  </a>
                  <a href="http://cn.medi-flower.com">
                    <div id="cn"></div>
                  </a>
                  <a href="http://jp.medi-flower.com">
                    <div id="jp"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
